<!--
 * @Description: 
 * @Author: yuxin
 * @Date: 2024-12-10 09:56:00
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-04-17 10:03:30
 * @FilePath: \mgr_web\src\components\page\Pagination.vue
-->
/**
* 分页组件
*/ 
<template >
  <div id="Pagination" class="Pagination">
  <el-pagination class="page-box" @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="childMsg.currentPage" :page-sizes="pageSizes" :page-size="childMsg.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="childMsg.total">
  </el-pagination>
  </div>
</template>
<script>
export default {
  name: "Pagination",
  props: ['childMsg', 'pageSizes'],
  data() {
    return {
      pageparm: {
        currentPage: this.childMsg.currentPage || this.childMsg.pageNum,
        pageSize: this.childMsg.pageSize
      }
    }
  },
  created() {
    // this.pageparm.currentPage = this.childMsg.currentPage;
    // this.pageparm.pageSize = this.childMsg.pageSize;
  },
  // 2021/12/30 修改
  watch:{
    childMsg: {
       handler(val) {
        this.pageparm = val;
      },
      deep: true, // 深度监听
      immediate: true, // 初次监听即执行 
    }   
  },
  methods: {
    handleSizeChange(val) {
      /**
       * 子传父
       * 参数1 父元素方法
       * 参数2 数据
       */
      this.pageparm.pageSize = val
       this.pageparm.currentPage = 1
      console.log(this.pageparm)
      this.$emit('callBack', this.pageparm,1)
    },
    handleCurrentChange(val) {
      /**
       * 子传父
       * 参数1 父元素方法
       * 参数2 数据
       */
      // console.log('页码改变')
      this.pageparm.currentPage = val
      // console.log("测试页码");
      // console.log(this.pageparm)
      this.$emit('callBack', this.pageparm,2)
    }
  }
}
</script>

<style lang="scss">
.Pagination{
  display: flex;
  justify-content: flex-end;
}
.page-box {
  // padding: 0px;
  margin-top: 15px ;
}
</style>
